import { useCanUseSimilaritySearch } from '../NLSSearch/useCanUseSimilaritySearch';
import { isHybridSearchPocSplitOn } from './utils';

/**
 * Context for AI: whether this portal is on the Unified Search PoC — the seeded
 * `assetbank_unified_search_internal_POC` split AND the ai_similarity_search ECA. The third gate,
 * `discover_spotlight_redesign_phase_0`, is structural: only the redesigned Spotlight calls this.
 *
 * Drives behaviour (which endpoint, which suppressions, badges) — not which localStorage key the
 * toggle persists under. That follows the split alone, so it can be decided synchronously.
 */
export const useIsHybridSearchEnabled = (): boolean => {
	const { canUseSimilaritySearch } = useCanUseSimilaritySearch();

	return isHybridSearchPocSplitOn() && canUseSimilaritySearch;
};
